import React from "react";
import gif from "../../../assets/img/spin.gif";

const Loader = () => {
  return (
    <div className="position-relative select-all-wrapper">
      <span className="select-all-loader">
        <img src={gif} alt="Loading..." />
      </span>
    </div>
  );
};
const LoaderSmall = () => {
  return (
    <div className="small-loader-main ">
      <span className="small-loader">
        <img src={gif} alt="Loading..." />
      </span>
    </div>
  );
};
const Loader2 = () => {
  return (
    <div className="loader-main-dev">
      <div className="loader-internal-dev ">
        <span className="">
          <img src={gif} alt="Loading..." />
        </span>
      </div>
    </div>
  );
};

export { Loader, Loader2, LoaderSmall };
